import { EnumMapper } from "@indietabletop/appkit";
import type { ReactNode } from "react";
import type { Gang } from "../../engine/Gang.ts";
import { Cap } from "./Cap.tsx";

export function ModelCostCap(props: {
  model: { cost: number; baseCost: number; gang: Gang };
}) {
  const { model } = props;
  const { capUsageStyle } = model.gang.mode;

  const mapper = new EnumMapper<typeof capUsageStyle, ReactNode>(
    {
      BASE_COST: (
        <Cap cost={model.baseCost} label="Base Cost" additionalInfo="Caps" />
      ),
      FULL_COST: (
        <Cap
          cost={model.cost}
          label="Cost"
          additionalInfo={`Base ${model.baseCost}`}
        />
      ),
      NONE: null,
    },
    null,
  );

  return mapper.get(capUsageStyle);
}
